import * as React from 'react'
import SVG from 'react-svg-inline'
import styled from 'styled-components'
import loaderIcon from '../../icons/common/loader.svg'

const Loader = styled.div`
  //margin: 0 0 2em;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  //padding: 1em;
  //margin: 0 auto 1em;
  //display: inline-block;
  //vertical-align: top;
  background-color: ${props =>
    props.backgroundColor
      ? props.theme.color[props.backgroundColor]
      : props.theme.color.backgroundRush};

  svg path,
  svg rect {
    fill: ${props => props.theme.color.turquoise};
  }
`

export default ({ backgroundColor }) => {
  return (
    <Loader backgroundColor={backgroundColor}>
      <SVG svg={loaderIcon} />
    </Loader>
  )
}
